var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "borderLine" },
    [
      _c(
        "section",
        {
          staticClass: "contan",
          style: {
            height: _vm.datas.blankHeight + "px",
            padding:
              "0px " + _vm.datas.margin + "px 0px " + _vm.datas.margin + "px",
          },
        },
        [
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.datas.borderType === 1,
                expression: "datas.borderType === 1",
              },
            ],
            staticStyle: {
              height: "1px",
              width: "100%",
              "border-top-width": "1px",
            },
            style: {
              "border-top-style": _vm.datas.borderLineType,
              "border-top-color": _vm.datas.borderColor,
            },
          }),
        ]
      ),
      _vm._v(" "),
      _vm._t("deles"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }